module.exports = __webpack_public_path__ + "static/media/SuraIconCirculationCard.65a25cde.svg";